import React, { useState } from 'react';
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaAddressCard } from 'react-icons/fa';
import "./contact.css";
import banner3 from "../../assets/nerbanner/contactimage.jpg";

// whatsapp number 8072712418
import { useNavigate } from 'react-router-dom';

function Contact() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
    });
    const [formStatus, setFormStatus] = useState("");
    const [error, setError] = useState("");
    const [captchaVerified, setCaptchaVerified] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault(); // prevent default form submission
        const { fullName, email, phone, subject, message } = formData;
    
        // Format message
        const whatsappMessage = `Name: ${fullName}%0AEmail: ${email}%0APhone: ${phone}%0ASubject: ${subject}%0AMessage: ${message}`;
    
        // Redirect to WhatsApp chat
        window.open(`https://wa.me/918072712418?text=${whatsappMessage}`, '_blank');
    };
    
  


    return (
        <>

            <section>
                <div className="image-all-banner">
                    <img src={banner3} alt="About Us" className="image-bg-all" />
                    <div className="overlay-all-page">
                        <h2 className="fade-in-text">Contact Us</h2>
                    </div>
                </div>
            </section>

            <section className="section-padding contact-section">
                <div className="container">
                    <div className="row">
                        {/* Contact Form */}
                        <div className="col-sm-6">
                            <div className="section-title-s2">
                                <span>Contact Us</span>
                                <h3>Keep In Touch</h3>
                            </div>
                            <div className="contact-form">
                                <form  onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-sm-6 mb-3">
                                            <div className="single-input form-group">
                                                <input
                                                    type="text"
                                                    name="fullName"
                                                    placeholder="Your Name"
                                                    value={formData.fullName}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-sm-6 mb-3">
                                            <div className="single-input form-group">
                                                <input
                                                    type="email"
                                                    name="email"
                                                    placeholder="Email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-sm-6 mb-3">
                                            <div className="single-input form-group">
                                                <input
                                                    type="text"
                                                    name="subject"
                                                    placeholder="Subject"
                                                    value={formData.subject}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-sm-6 mb-3">
                                            <div className="single-input form-group">
                                                <input
                                                    type="tel"
                                                    name="phone"
                                                    placeholder="Phone"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-sm-12 mb-3">
                                            <div className="single-input form-group">
                                                <textarea
                                                    name="message"
                                                    placeholder="Message"
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                    required
                                                ></textarea>
                                            </div>
                                        </div>



                                        <p className="form-message">
                                            {error && <span className="error-message">{error}</span>}
                                            {formStatus && <span className="success-message">{formStatus}</span>}
                                        </p>

                                        <div className="col-sm-12">
                                            <div className="single-input form-group">
                                                <button className="theme-btn" type="submit" disabled={loading}>
                                                    {loading ? "Sending..." : "Submit"}
                                                </button>                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        {/* Contact Info */}
                        <div className="col-sm-5 col-sm-offset-1">
                            <div className="contact-info">
                                <ul>
                                    <li>
                                        <div className="single-info">
                                            <div className="info-icon">
                                                <FaAddressCard />
                                            </div>
                                            <div className="info-content">
                                                <p>No:21, Vinayaga Nagar, Okkiyam, <br />Thoraipakkam, Chennai-600097</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="single-info">
                                            <div className="info-icon">
                                                <FaPhoneAlt />
                                            </div>
                                            <div className="info-content">
                                                <p>+91 8072712418</p>
                                                {/* <p>044-48570414</p> */}
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="single-info">
                                            <div className="info-icon">
                                                <FaEnvelope />
                                            </div>
                                            <div className="info-content">
                                                <p>info@triplette.in</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            {/* Google Map */}
                            <div className="google-map">
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.362524150823!2d80.23213717373139!3d12.948638815383935!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525c55e3f61a11%3A0xb87517f7edb01765!2sFazo%20Academy!5e0!3m2!1sen!2sin!4v1739266975762!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

                                {/* <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d198710.35112897935!2d-98.51489117772236!3d38.904562823631146!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54eab584e432360b%3A0x1c3bb99243deb742!2sUnited+States!5e0!3m2!1sen!2sin!4v1471865832140"
                                    allowFullScreen=""
                                ></iframe> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    );
}

export default Contact;
